module.exports = __webpack_public_path__ + "images/audi_image6.fbdfdd28.png";